import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import { parseIconHostParamsObject } from './utils.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["category", "params", "size"];

var IconHost = function IconHost(_ref) {
  var _ref$category = _ref.category,
      category = _ref$category === void 0 ? "content-icons-v2" : _ref$category,
      params = _ref.params,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx("img", _objectSpread({
    src: "https://api.seismic.com/icon-host/v1/".concat(category, "/icon?").concat(parseIconHostParamsObject(params)),
    alt: "".concat(category, " icon"),
    "aria-hidden": true,
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24
  }, rest));
};

IconHost.propTypes = {
  "category": _PropTypes.oneOf(["content-icons-v2", "content-icons", "content-planner-icons", "folder-icons-v2", "folder-icons"]),
  "params": _PropTypes.oneOfType([_PropTypes.shape({
    contentTypeNumber: _PropTypes.number,
    format: _PropTypes.string,
    isDynamic: _PropTypes.bool,
    modifier: _PropTypes.string,
    url: _PropTypes.string,
    versionTypeNumber: _PropTypes.number
  }), _PropTypes.shape({
    type: _PropTypes.string.isRequired
  }), _PropTypes.shape({
    contextualType: _PropTypes.string,
    folderTypeNumber: _PropTypes.number,
    systemType: _PropTypes.string,
    type: _PropTypes.string
  })]),
  "size": _PropTypes.oneOf([16, 20, 24, 32])
};
IconHost.displayName = "IconHost";

export { IconHost };
